import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";

import "./PasswordBoxControl.css";

interface IPasswordBoxProps {
    id?: string;
    dataCy?: string;
    value?: string;
    placeholder?: string;
    onChange: (value: string) => void;
    keyOffset?: number;
    onEnterPress: () => void;

    className: string;
    capsLockOnMessage?: string;
}

class PasswordBoxState {
    public encryptedText: string = "";
    public clearPassword: string = "";
    public isCapsLockOn: boolean = false;
}

class PasswordStateBoxControl extends BaseReactComponent<IPasswordBoxProps, PasswordBoxState> {
    public myleHelper = new MyleHelper();

    constructor(props: IPasswordBoxProps) {
        super(props);

        this.state = new PasswordBoxState();
    }

    // IF YOU TOUCH THIS CODE YOU HAVE TO TEST THE LOGIN FOR : PC, MAC, IPhone, Android, Virtual Key Board
    public render(): JSX.Element {
        return (
            <div className="passwordbox">
                <input
                    id={this.props.id}
                    data-cy={this.props.dataCy}
                    key={this.props.id}
                    className={this.props.className}
                    placeholder={this.props.placeholder}
                    type="password"
                    value={this.state.encryptedText}
                    onFocus={() => this.clearText()}
                    onKeyDown={e => this.onkeydown(e)}
                    onChange={e => this.onChange(e)}
                />
                {this.props.capsLockOnMessage && this.state.isCapsLockOn && (
                    <p className="capslockon-message">
                        {this.props.capsLockOnMessage}
                    </p>
                )}
            </div>
        );
    }

    private onkeydown(e: React.KeyboardEvent): void {
        var keycode = e.which;
        // IF YOU TOUCH THIS CODE YOU HAVE TO TEST THE LOGIN FOR : PC, MAC, IPhone, Android, Virtual Key Board

        if (e.ctrlKey) {
            if (keycode == 65) {
                this.clearText();
            }
        }
        else if (keycode == 8 || keycode == 46) {
            this.clearText();
        }
        else if (keycode == 13) {
            this.props.onEnterPress();
        }

        this.showOrHideCapsLockOnMessage(e.getModifierState?.("CapsLock"));
    }

    private onChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var newText: string = e.target.value;
        var inputChar = "";

        // IF YOU TOUCH THIS CODE YOU HAVE TO TEST THE LOGIN FOR : PC, MAC, IPhone, Android, Virtual Key Board
        if (newText != null && newText.length > 0 && newText.length == this.state.encryptedText.length + 1) {
            inputChar = newText.substr(newText.length - 1, 1);

            this.mutateState(
                s => {
                    s.clearPassword = s.clearPassword + inputChar;
                    s.encryptedText = s.encryptedText + "x";
                },
                () => this.props.onChange(this.state.clearPassword)
            );
        }
        else {
            this.clearText();
        }
    }

    private clearText(): void {
        this.mutateState(
            s => {
                s.encryptedText = "";
                s.clearPassword = "";
            },
            () => this.props.onChange(this.state.encryptedText)
        );
    }

    private showOrHideCapsLockOnMessage(capsLockOn: boolean): void {
        if (this.state.isCapsLockOn === capsLockOn)
            return;

        this.mutateState(s => s.isCapsLockOn = capsLockOn);
    }
}

export { PasswordStateBoxControl };
